import React from "react";

const Lock = ({style = {}, size = "36", className = "", fill = "#73788B", viewBox = "0 0 36 36"}) => (
    <svg
        width={size}
        style={style}
        height={size}
        viewBox={viewBox}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={`${className || ""}`}
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
        <path
            className="u_fill"
            d="M29.284 14.8h1.58c.42 0 .821.169 1.118.469.296.3.462.707.462 1.131v16c0 .424-.166.831-.462 1.131a1.57 1.57 0 01-1.118.469H5.58a1.57 1.57 0 01-1.117-.469A1.61 1.61 0 014 32.4v-16c0-.424.166-.831.463-1.131A1.57 1.57 0 015.58 14.8h1.58v-1.6c0-1.47.287-2.927.843-4.286A11.21 11.21 0 0110.4 5.28a11.054 11.054 0 013.59-2.427 10.943 10.943 0 018.465 0 11.053 11.053 0 013.589 2.427 11.21 11.21 0 012.398 3.634c.556 1.359.842 2.815.842 4.286v1.6zm-3.16 0v-1.6a8.051 8.051 0 00-2.315-5.657A7.852 7.852 0 0018.222 5.2a7.852 7.852 0 00-5.587 2.343 8.05 8.05 0 00-2.314 5.657v1.6h15.803zm-9.482 6.4v6.4h3.16v-6.4h-3.16z"
            fill={fill}
        />
    </svg>
);

export default Lock;